<script setup>
import { ref, watch } from 'vue'
const props = defineProps({ modelValue: { type: String, default: '' }, label: String, id: String,
  disabled: Boolean, invalid: Boolean, errorId: String, includeSeconds: { type: Boolean, default: true } })
const emit = defineEmits(['update:modelValue'])
const raw = ref(props.modelValue)
watch(() => props.modelValue, value => { if (value !== raw.value) raw.value = value })
function update(event) {
  raw.value = event.target.value
  emit('update:modelValue', raw.value)
}
</script>
<template>
  <label class="history-date-time-field" :for="id"><span>{{ label }}</span>
    <input :id="id" :value="raw" type="datetime-local" :step="includeSeconds ? 1 : 60"
      min="1000-01-01T00:00" max="9999-12-31T23:59:59" :disabled="disabled"
      :aria-invalid="invalid" :aria-describedby="invalid ? errorId : undefined" @input="update">
  </label>
</template>
